module.exports = "<mz-modal #confirmModal [options]=\"modalOptions\">\r\n  <mz-modal-content>\r\n    {{ text }}\r\n  </mz-modal-content>\r\n  <mz-modal-footer>\r\n    <button mz-button [flat]=\"true\" mz-modal-close>Anuluj</button>\r\n    <button mz-button [flat]=\"true\" class=\"red-text\" (click)=\"confirm()\">Usuń</button>\r\n  </mz-modal-footer>\r\n</mz-modal>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/services/prompt/confirm/confirm.component.html
// module id = ../../../../../src/app/services/prompt/confirm/confirm.component.html
// module chunks = main